import { useState } from 'react'
import useIsomorphicLayoutEffect from 'hooks/useIsomorphicLayoutEffect'
import css from './styles.module.scss'
import classnames from 'classnames/bind'
import Img from "next/legacy/image"

const cx = classnames.bind(css)

const TableGroup = ({ open = false, category, fields }) => {
  const [isOpen, setIsOpen] = useState(false)

  useIsomorphicLayoutEffect(() => {
    setIsOpen(open)
  }, [])

  const toggleCategory = () => setIsOpen(!isOpen)

  return (
    <>
      <div className={cx(css.row)} onClick={toggleCategory}>
        <div
          className={cx(css.category, css.cell, open ? css.borderRadius : '')}
        >
          <span>{category}</span>
        </div>
        <div className={cx(css.field, css.cell, css.disappearOnMobile)}></div>
        <div className={cx(css.field, css.cell)}></div>
      </div>
      {fields.map((field, index) => (
        <div className={cx(css.row)} key={index}>
          <div className={cx(css.fieldName, css.cell)}>{field.name}</div>
          <div className={cx(css.field, css.cell)}>
            {field.firstCMS.text && <span>{field.firstCMS.text}</span>}
            {!field.firstCMS.text && (
              <div>
                <Img
                  src={
                    field.firstCMS.mark
                      ? '/assets/icons/correct.svg'
                      : '/assets/icons/wrong.svg'
                  }
                  width={24}
                  height={24}
                />
              </div>
            )}
          </div>
          <div className={cx(css.field, css.cell)}>
            {field.secondCMS.text && <span>{field.secondCMS.text}</span>}
            {!field.secondCMS.text && (
              <div>
                <Img
                  src={
                    field.secondCMS.mark
                      ? '/assets/icons/correct.svg'
                      : '/assets/icons/wrong.svg'
                  }
                  width={24}
                  height={24}
                />
              </div>
            )}
          </div>
        </div>
      ))}
    </>
  )
}

export default TableGroup
